import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C50601AF-7AD6-4677-B8B3-181B978613A8
 * name keyboard-f5
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-f5.svg
 * tags
 */
export const KeyboardF5Icon = createSvgIcon(<><path d="M5 7H11V9H7V11H10V13H7V17H5V7M13 7H19V9H15V11H17C18.11 11 19 11.9 19 13V15C19 16.11 18.11 17 17 17H13V15H17V13H13V7Z" /></>, 'KeyboardF5Icon');
export default KeyboardF5Icon